<template>
  <div>
    <el-form inline :model="searchForm" :loading="searching">
      <el-form-item label="手机号">
        <el-input placeholder="多个可以用逗号分割" v-model="searchForm.phones">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(0)" />
        </el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="searchForm.names" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(1)" />
        </el-input>
      </el-form-item>
      <el-form-item label="联系人手机">
        <el-input v-model="searchForm.contactPhones" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(2)" />
        </el-input>
      </el-form-item>
      <el-form-item label="联系人姓名">
        <el-input v-model="searchForm.contactNames" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(3)" />
        </el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="searchForm.remarks" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(4)" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
        <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" style="margin-top: 1rem" border
              :header-cell-style="{background:'#eee',color:'black'}"
              max-height="400"
              @select="selectItem"
              @select-all="selectAll"
              ref="tableView"
    >
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="item.flex"
                       v-if="item.type !== 3 && item.type !== 4"
                       :type="item.type === 2?'selection':''"
      >
      </el-table-column>
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="item.flex"
                       v-if="item.type === 4"
      >
        <template slot-scope="scope">
          <el-row style="margin-top: 10px" v-for="(actionItem, actionIndex) in scope.row[item.key]" :key="'btn_' + actionIndex">
            <el-tag size="medium" >
              {{actionItem[item.tagValueKey]}}
            </el-tag>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 1rem"
                   :page-size.sync="pageSize"
                   :total.sync="totalCount"
                   :current-page.sync="curPage"
                   @size-change="search"
                   @current-change="search"
                   :page-sizes="[20, 100, 200, 500, 1000]"
                   layout="total, sizes, prev, pager, next, jumper"
    />
    <el-dialog title="批量操作" :visible.sync="showMultipleEditBox">
      <el-card shadow="never" style="flex-wrap: wrap; justify-content: space-around">
        <el-tag v-for="(tag, index) in tags" :key="index" closable style="margin: 0.2rem">
          {{tag}}
        </el-tag>
        <el-input ref="multipleInput" style="margin: 0.2rem; width: 120px" size="small" v-model="multipleEditName" placeholder="新增-回车保存" @keyup.enter.native="change"/>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doneAction">确 定</el-button>
        <el-button @click="clearAction">清 除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {addUserToGroup, queryCustomerFromGroup, removeUserToGroup} from './groupApi'

export default {
  name: 'addGroupMember',
  data () {
    return {
      searchForm: {
        curPage: 1,
        pageSize: 20,
        phones: '',
        remarks: '',
        contactPhones: '',
        contactNames: '',
        names: ''
      },
      searching: false,
      multipleEditBoxType: 0,
      tags: [],
      showMultipleEditBox: false,
      multipleEditName: '',
      showEditCustomer: false,
      editCustomerTitle: '新增顾客',
      curPage: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 20,
      list: [],
      listKeyMap: []
    }
  },
  props: {
    groupData () {
      return null
    }
  },
  created () {
    if (this.groupData) {
      this.searchForm.groupId = this.groupData.customerGroupId
    }
    this.search()
  },
  watch: {
    groupData (d) {
      this.searchForm = {
        curPage: 1,
        pageSize: 20,
        phones: '',
        remarks: '',
        contactPhones: '',
        contactNames: '',
        names: '',
        groupId: d.customerGroupId
      }
      this.search()
    }
  },
  methods: {
    search () {
      this.searching = true
      queryCustomerFromGroup(this.searchForm).then(rsp => {
        this.searching = false
        const {code, message, result} = rsp
        if (code === 0) {
          const { pagination, values } = result
          const { list, curPage, pageSize, totalCount, totalPage } = pagination
          this.curPage = curPage
          this.pageSize = pageSize
          this.totalPage = totalPage
          this.totalCount = totalCount
          this.list = list
          this.listKeyMap = values
          setTimeout(() => {
            for (let i = 0; i < list.length; i++) {
              const tempItem = list[i]
              const { groupMember } = tempItem
              if (groupMember === true) {
                this.$refs.tableView.toggleRowSelection(tempItem, true)
              }
            }
          }, 100)
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.searching = false
      })
    },
    reset () {
      this.searchForm.phones = ''
      this.searchForm.contacts = ''
      this.searchForm.names = ''
      this.searchForm.contactNames = ''
      this.searchForm.contactPhones = ''
      this.searchForm.remarks = ''
    },
    addMore (type) {
      this.multipleEditBoxType = type
      const key = this.keyForType(type)
      if (key === null) {
        return
      }
      const tempArray = this.searchForm[key].split(',')
      for (let i = tempArray.length - 1; i >= 0; i--) {
        const tempText = tempArray[i].trim()
        if (tempText.length === 0) {
          tempArray.splice(i, 1)
        }
      }
      this.tags = tempArray
      this.showMultipleEditBox = true
      setTimeout(() => {
        this.$refs.multipleInput.focus()
      }, 100)
    },
    keyForType (type) {
      let key = null
      if (type === 0) {
        key = 'phones'
      } else if (type === 1) {
        key = 'names'
      } else if (type === 2) {
        key = 'contactPhones'
      } else if (type === 3) {
        key = 'contactNames'
      } else if (type === 4) {
        key = 'names'
      }
      return key
    },
    doneAction () {
      this.showMultipleEditBox = false
      const text = this.tags.join(',')
      const key = this.keyForType(this.multipleEditBoxType)
      this.searchForm[key] = text
    },
    clearAction () {
      this.tags = []
      this.multipleEditName = ''
    },
    change () {
      const tempName = this.multipleEditName.trim()
      if (tempName.length === 0) {
        return
      }
      if (this.tags.indexOf(tempName) < 0) {
        this.tags.push(tempName)
      }
      this.multipleEditName = ''
      this.$refs.multipleInput.focus()
    },
    selectItem (a, b) {
      const isChecked = a.indexOf(b) >= 0
      const { customerId } = b
      const data = {}
      data.groupId = this.groupData.customerGroupId
      data.customerIds = [customerId]
      const thenRsp = (rsp) => {
        const { code } = rsp
        if (code === 0) {
          let msg = '添加成功'
          if (isChecked === false) {
            msg = '删除成功'
          }
          this.$message.success(msg)
        } else {
          const { message } = rsp
          this.$message.error(message)
          this.search()
        }
      }
      if (isChecked === true) {
        addUserToGroup(data).then(thenRsp).catch(null)
      } else {
        removeUserToGroup(data).then(thenRsp).catch(null)
      }
    },
    selectAll (a) {
      const data = {}
      data.groupId = this.groupData.customerGroupId
      data.customerIds = []
      for (let i = 0; i < this.list.length; i++) {
        const tempItem = this.list[i]
        const { customerId } = tempItem
        data.customerIds.push(customerId)
      }
      const thenRsp = (rsp) => {
        const { code } = rsp
        if (code === 0) {
          let msg = '添加成功'
          if (a.length > 0) {
            msg = '删除成功'
          }
          this.$message.success(msg)
        } else {
          const { message } = rsp
          this.$message.error(message)
          this.search()
        }
      }
      if (a.length > 0) {
        addUserToGroup(data).then(thenRsp).catch(null)
      } else {
        removeUserToGroup(data).then(thenRsp).catch(null)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerGroup/addGroupMember.vue